export default __webpack_public_path__ + "static/media/calendar-alt.5e163a33.svg";